import * as _ from "lodash-es";
import React, { useContext, useEffect } from "react";
import AccessTypesEnum from "../../../../../models/AccessTypesEnum";
import IOnResendTokenEmailDTO from "../../../../../models/DTO/IOnResendTokenEmailDTO";
import EndpointsEnum from "../../../../../models/EndpointsEnum";
import IConnection_Token from "../../../../../models/IConnection_Token";
import UserTypesEnum from "../../../../../models/UserTypesEnum";
import OwButton from "../../../../shared/OwButton/OwButton";
import MasterUser from "../../MasterUser/MasterUser";
import IUiSocketSetup from "../../../../../models/IUiSocketSetup";
import SupplierContext from "../../../../../contexts/SupplierContext";
import UserContext from "../../../../../contexts/UserContext";
import { SocketContext } from "../../../../../contexts/SocketContext";
import ITokenResetUserPasswordDTO from "../../../../../models/DTO/ITokenResetUserPasswordDTO";
import IOnTokenResetUserPasswordDTO from "../../../../../models/DTO/IOnTokenResetUserPasswordDTO";
import NotificationLevelEnum from "../../../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../../../models/NotificationPositionEnum";
import INotification from "../../../../../models/INotification";
import UiContext from "../../../../../contexts/UiContext";

type Props = {
    supplierUserToken: IConnection_Token;
    toggleDockFn: (token: IConnection_Token) => void;
    toggleConfirmDeleteFn: (token: IConnection_Token, rowIndex: number, rowElem: HTMLElement | null) => void;
    resendTokenEmailFn: (token: IConnection_Token) => void;
    rowIndex: number;
};

const SupplierUserActionBtns = (props: Props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);
    const socket = useContext(SocketContext)!;
    const uiConext = useContext(UiContext);

    const [resendTokenBtnActive, setResendTokenBtnActive] = React.useState(false);
    const [resetPasswordActive, setResetPasswordActive] = React.useState(false);

    const onResendTokenEmail = (data: IOnResendTokenEmailDTO) => {
        if (data.tokenGuid === props.supplierUserToken.guid) {
            setResendTokenBtnActive(false);
        }
    };

    const onResetUserPassword = (data: IOnTokenResetUserPasswordDTO) => {
        if (data.tokenGuid === props.supplierUserToken.guid) {
            setResetPasswordActive(false);

            const notification: INotification = {
                message: "successfully_started_password_reset",
                level: NotificationLevelEnum.success,
                position: NotificationPositionEnum.bc,
            };

            uiConext.notifyFn(null, notification);
        }
    };

    const sockets: IUiSocketSetup[] = [
        { endpoint: EndpointsEnum.TokenOnResendTokenEmail, fn: onResendTokenEmail },
        { endpoint: EndpointsEnum.TokenOnAdminResetUserPassword, fn: onResetUserPassword },
    ];

    useEffect(() => {
        for (const _socket of sockets) {
            socket.on(_socket.endpoint, _socket.fn);
        }

        return () => {
            for (const _socket of sockets) {
                socket.off(_socket.endpoint, _socket.fn);
            }
        };
    }, []);

    const resetUserPassword = () => {
        const payload: ITokenResetUserPasswordDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            tokenGuid: props.supplierUserToken.guid,
        };

        socket.emit(EndpointsEnum.TokenAdminResetUserPassword, payload);

        setResetPasswordActive(true);
    };

    const resendTokenEmail = () => {
        props.resendTokenEmailFn(props.supplierUserToken);
        setResendTokenBtnActive(true);
    };

    const getAccessLevelActions = (_supplierUserToken: IConnection_Token) => {
        if (
            !_.isNil(_supplierUserToken.User) &&
            _supplierUserToken.access_type_id === AccessTypesEnum.RESTRICTED &&
            !_supplierUserToken.is_sales_rep
        ) {
            return (
                <OwButton
                    supplierModel={supplierModel}
                    isSupplierVendorOverride={true}
                    leftIconClass={"fas fa-pencil"}
                    className={"me-md-2 mb-2 mb-md-0 btn-primary"}
                    title={"edit_vendor_access"}
                    fn={() => {
                        props.toggleDockFn(_supplierUserToken);
                    }}
                />
            );
        } else {
            return null;
        }
    };

    const supplierUserToken = props.supplierUserToken;

    const accessLevelActions = getAccessLevelActions(supplierUserToken);

    const rowElem = document.getElementById(`row-${props.rowIndex}`);

    if (rowElem) {
        // console.log("rowElem", rowElem, rowElem.getBoundingClientRect());
    }

    return (
        <div className={"no-wrap"}>
            <MasterUser isMaster={!!supplierUserToken.is_master} title={"master_user"} icon={"fad fa-key"} />

            <span className={supplierUserToken.is_master ? "d-none" : ""}>
                {accessLevelActions}

                <span className={!_.isNil(supplierUserToken.user_id) ? "d-none" : ""}>
                    <OwButton
                        disableOnActive={true}
                        active={resendTokenBtnActive}
                        fn={resendTokenEmail}
                        leftIconClass={"far fa-envelope"}
                        title={"resend"}
                        className={"btn-primary me-md-2 mb-2 mb-md-0"}
                    />
                </span>

                <span className={!supplierUserToken.user_id ? "d-none" : ""}>
                    <OwButton
                        disableOnActive={true}
                        active={resetPasswordActive}
                        fn={resetUserPassword}
                        leftIconClass={"far fa-refresh"}
                        title={"reset_password"}
                        className={"btn-primary me-md-2 mb-2 mb-md-0"}
                    />
                </span>

                {userModel.isSupplierUser && userModel.userType?.id === UserTypesEnum.ADMIN ? (
                    <OwButton
                        fn={(e: any) => {
                            props.toggleConfirmDeleteFn(supplierUserToken, props.rowIndex, rowElem);
                        }}
                        leftIconClass={"far fa-trash-alt"}
                        title={"revoke"}
                        className={"btn-danger"}
                    />
                ) : null}
            </span>
        </div>
    );
};

export default SupplierUserActionBtns;
